import React from 'react';
import {Button, ButtonTier, ButtonType, Colors} from '../index';
import {uniquePreviousItems} from '../../helpers/loadPreviousCart';
import './OfferingHeader.scss';
import {logger} from '../../utilities';
import {useAppStore} from "../../data/AppStore";
import {shallow} from "zustand/shallow";

const LOG_PREFIX = '[OfferingHeader.js]';

const OfferingHeader = ({offering, toggleEmailModal, viewCart}) => {
    logger.debug(LOG_PREFIX, '.render');
    const [CART] = useAppStore((state) => [state.CART], shallow)
    return (
        <div className={'OfferingContentHeader'}>
            <div>
                {
                    (offering.json_data && offering.json_data.nickname) ?
                        offering.json_data.nickname :
                        offering.sales_option
                }
            </div>
            <Button
                onClick={toggleEmailModal}
                label={'Email'}
                type={ButtonType.Email}
                tier={ButtonTier.Secondary}
            />
            <Button
                onClick={viewCart}
                label={`Current Cart (${Object.keys(CART.quantity).length}) Previous Cart (${uniquePreviousItems(CART)})`}
                colorTheme={Colors.Orange}
            />
        </div>
    );
}

export default OfferingHeader;